import { useRouter } from 'vue-router'
import { useCookies } from '@vueuse/integrations/useCookies'
import { HelmClient } from '@helm/services/api/client'
import { AxiosHttpWrapper } from '@helm/services/api/wrapper/AxiosHttpWrapper'
import type { HelmApi } from '@helm/types/composables/helmApi'
import { CACHE_KEY } from '@/constants/query'
import ENV from '@/constants/env'
import { COOKIE_OPTIONS } from '@/constants/cookies'
import { computed } from 'vue'

const helmHost = ENV.helmHost
const mainDomain = ENV.helmDomain()

const useHelmApi = (): HelmApi => {
    const router = useRouter()
    const cookies = useCookies()

    const api = new HelmClient(
        {
            BASE: helmHost
        },
        AxiosHttpWrapper
    )

    const logout = () => {
        cookies.remove(`helm_access_token`, {
            ...COOKIE_OPTIONS,
            domain: `.${mainDomain}`
        })

        localStorage.removeItem(CACHE_KEY)

        router.push({ name: `logout` })
    }

    const isLoggedIn = computed(() => !!cookies.get(`helm_access_token`))

    return {
        logout,
        api,
        isLoggedIn
    }
}

export default useHelmApi
